import { orgSelectors } from 'ducks/orgs'
import CreditCardCapTooltip from 'elements/cashFlow/CreditCardCapTooltip'
import { styled } from 'opensolar-ui'
import React, { useMemo } from 'react'
import { SelectArrayInput } from 'react-admin'
import { useSelector } from 'react-redux'
import { getHasPaymentCap, showCreditCardTooltipCap } from 'util/cashFlow/configuration'

type PropTypes = {
  paymentIndex: number
  paymentMethods: { id: string; name: string; max_payment_amount: number }[]
  selectedPaymentMethods: any
}

const StyledSelectArrayInput = styled(SelectArrayInput)({
  margin: '10px 0',
})

const AcceptedPaymentMethodsField: React.FC<PropTypes> = (props) => {
  const orgCountry = useSelector(orgSelectors.getOrgIso2)

  const paymentMethodsLabel = useMemo(() => {
    if (props.paymentMethods.length > 0) {
      const hasPaymentCap = getHasPaymentCap(props.paymentMethods, orgCountry)

      if (props.selectedPaymentMethods && showCreditCardTooltipCap(props.selectedPaymentMethods, hasPaymentCap)) {
        return <CreditCardCapTooltip label="Accepted Payment Methods" />
      }
    }
    return 'Accepted Payment Methods'
  }, [props.selectedPaymentMethods, props.paymentMethods])

  const availableIds = useMemo(() => new Set(props.paymentMethods.map((m) => m.id)), [props.paymentMethods])
  const filterSelected = (value: any) => (Array.isArray(value) ? value.filter((id) => availableIds.has(id)) : [])

  return (
    <StyledSelectArrayInput
      label={paymentMethodsLabel}
      source={`payment_milestone_configurations[${props.paymentIndex}].accepted_payment_methods`}
      choices={props.paymentMethods}
      fullWidth={true}
      format={filterSelected}
      parse={filterSelected}
    />
  )
}

export default AcceptedPaymentMethodsField
